<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="nationalityPlace.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="!canEditOrInsert"
                  data-cy="description-input"
                />
                <small
                  data-cy="v-description-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="sigla"
              rules="required"
            >
              <b-form-group
                label="Sigla"
                label-for="v-sigla"
              >
                <b-form-input
                  id="v-sigla"
                  v-model="nationalityPlace.sigla"
                  :state="errors.length > 0 ? false : null"
                  placeholder="sigla"
                  :disabled="!canEditOrInsert"
                  data-cy="sigla-input"
                />
                <small
                  data-cy="v-sigla-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            v-if="nationalityPlace.id"
            cols="12"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="nationalityPlace.ativo"
                :checked="nationalityPlace.ativo"
                name="check-button"
                switch
                inline
                :disabled="!canEditOrInsert"
                data-cy="active-checkbox"
              >
                {{ nationalityPlace.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'

import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('nationalitySettingsModule', {
      nationality: state => state.nationality,
    }),
    canInsert() {
      return verificarPermissao('ROLE_NACIONALIDADE_INSERIR')
    },
    canEdit() {
      return verificarPermissao('ROLE_NACIONALIDADE_ATUALIZAR')
    },
    canEditOrInsert() {
      return (
        (!this.nationalityPlace.id && this.canInsert)
        || (this.nationalityPlace.id && this.canEdit)
      )
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Nacionalidade',
      required,
      nationalityPlace: {
        nome: '',
        sigla: '',
        ativo: true,
      },
    }
  },
  mounted() {
    this.nationalityPlace = JSON.parse(JSON.stringify(this.nationality))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('nationalitySettingsModule/resetNacionality')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.nationalityPlace.id) {
            this.$store
              .dispatch(
                'nationalitySettingsModule/editNacionality',
                this.nationalityPlace,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch(
                'nationalitySettingsModule/insertNewNacionality',
                this.nationalityPlace,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.nationalityPlace = {
        nome: '',
        sigla: '',
        ativo: true,
      }
    },
  },
}
</script>
